import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme.js';

export default class FeaturedArticle extends Component {
  render() {
    let imageSource = '';
    if(this.props.post.thumbnail_src) {
      imageSource = this.props.post.thumbnail_src ? this.props.post.thumbnail_src : '/assets/article_summary_image.png';
    } else {
      imageSource = this.props.post.image_src ? this.props.post.image_src : '/assets/article_summary_image.png';
    }

    return (
      <Link className={css(styles.container)} to={{
          pathname: `/${this.props.post.content_type}/${this.props.post.slug}`,
          state: {
            post: this.props.post
          }
        }}>
        <div className={css(styles.image_container)}>
          <img className={css(styles.image)} src={imageSource} />
        </div>
        <div className={css(styles.title_container)}>
          <div className={css(styles.title)}>
            {this.props.post.title}
          </div>
        </div>
      </Link>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    color: Theme.dark_grey,
    transition: 'all 180ms ease-in-out',
    ':hover': {
      opacity: 0.7,
      color: Theme.primary,
    },
  },
  image_container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
  image: {
    width: 65,
    maxHeight: 65,
  },
  title_container: {
    display: 'flex',
    flex: 3,
    alignItems: 'center',
  },
  title: {
    fontFamily: Theme.fontFamily,
    letterSpacing: 1,
    lineHeight: '20px',
    paddingLeft: 10,
    fontSize: 13,
  },
})



// WEBPACK FOOTER //
// ./src/components/FeaturedArticle/index.js